import request from '@/utils/request.js'

/* 登录系统生成会话 */
export function loginMan (userName, passWord) {
  return request({
    url: '/jsp/loginman.jsp?loginguid={loginguidng2}&format=mjson&classid=loginuser&action=login',
    method: 'post',
    data: {'userid': userName, 'md5sn': passWord, 'entcode': 'boloni', 'isportal': 2}
  })
}

/* 新增供应商账号 */
export const addUser = (data) => {
  return request({
    url: '/api/addUser',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 供应商登录 */
export function loginUser (userName, passWord) {
  return request({
    url: '/api/loginUser/' + userName + '/' + passWord,
    method: 'get'
  })
}

/* 查询供应商信息(主表) */
export function getGys (userName) {
  return request({
    url: '/api/getGys/' + userName,
    method: 'get'
  })
}

/* 新增供应商主表（基本信息） */
export const addGys = (data) => {
  return request({
    url: '/api/addUser_Gys',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 新增供应商主表（基本信息） */
export const udMate = (data) => {
  return request({
    url: '/api/udMate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 新增子表 （销售前五名客户） */
export const addPeRaTe = (data, userName) => {
  return request({
    url: '/api/addPeRaTe/' + userName,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 查询子表数据 （销售前五名客户） */
export function getPeRaTe (userName) {
  return request({
    url: '/api/getPeRaTe/' + userName,
    method: 'get'
  })
}

/* 删除子表数据 （销售前五名客户） */
export function delPeRaTe (keyId) {
  return request({
    url: '/api/delPeRaTe/' + keyId,
    method: 'delete'
  })
}

/* 新增子表 （竞品客户信息） */
export const addCompetitorCustomer = (data, userName) => {
  return request({
    url: '/api/addCompetitorCustomer/' + userName,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 查询子表数据 （竞品客户信息） */
export function getCompetitorCustomer (userName) {
  return request({
    url: '/api/getCompetitorCustomer/' + userName,
    method: 'get'
  })
}

/* 删除子表数据 （竞品客户信息） */
export function delCompetitorCustomer (keyId) {
  return request({
    url: '/api/delCompetitorCustomer/' + keyId,
    method: 'delete'
  })
}

/* 新增子表 （主要生产设备） */
export const addMain = (data, userName) => {
  return request({
    url: '/api/addMain/' + userName,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 查询子表数据 （主要生产设备） */
export function getMain (userName) {
  return request({
    url: '/api/getMain/' + userName,
    method: 'get'
  })
}

/* 删除子表数据 （主要生产设备） */
export function delMain (keyId) {
  return request({
    url: '/api/delMain/' + keyId,
    method: 'delete'
  })
}

/* 新增子表 （检测工具及设备） */
export const addTest = (data, userName) => {
  return request({
    url: '/api/addTest/' + userName,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 查询子表数据 （检测工具及设备） */
export function getTest (userName) {
  return request({
    url: '/api/getTest/' + userName,
    method: 'get'
  })
}

/* 删除子表数据 （检测工具及设备） */
export function delTest (keyId) {
  return request({
    url: '/api/delTest/' + keyId,
    method: 'delete'
  })
}

/* 新增子表 （主要原材料及配套厂家资料） */
export const addMateLine = (data, userName) => {
  return request({
    url: '/api/addMateLine/' + userName,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 查询子表数据 （主要原材料及配套厂家资料） */
export function getMateLine (userName) {
  return request({
    url: '/api/getMateLine/' + userName,
    method: 'get'
  })
}

/* 删除子表数据 （主要原材料及配套厂家资料） */
export function delMateLine (keyId) {
  return delMateLine({
    url: '/api/delPeRaTe/' + keyId,
    method: 'delete'
  })
}

/* 查询供货大类 */
export function getGhDl () {
  return request({
    url: '/api/getGhDl',
    method: 'get'
  })
}

/* 查询供货小类 */
export function getGhType (gys_ghdl) {
  return request({
    url: '/api/getGhType/' + gys_ghdl,
    method: 'get'
  })
}

/* 查询省份 */
export function getProvince () {
  return request({
    url: '/api/getProvince',
    method: 'get'
  })
}

/* 查询城市 */
export function getCity (ProvNice) {
  return request({
    url: '/api/getCity/' + ProvNice,
    method: 'get'
  })
}

/* 查询城市 */
export function getBaseCity (cityname) {
  return request({
    url: '/api/getBaseCity?name=' + cityname,
    method: 'get'
  })
}

/* 查询必要资料 */
export function getGhCl (gh_type) {
  return request({
    url: '/api/getGhCl/' + gh_type,
    method: 'get'
  })
}

/* 供应商信息提交 */
export const doSubmit = (userName) => {
  return request({
    url: '/api/submit/' + userName,
    method: 'get'
  })
}

/* 获取供应商合同资料 */
export function getgyshtzl (vendor_code) {
  return request({
    url: '/api/getgyshtzl/' + vendor_code,
    method: 'get'
  })
}

/* 新增/更新供应商合同资料 */
export const savegyshtzl = (data) => {
  return request({
    url: '/api/savegyshtzl',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 供应商合同资料提交 */
export const submithtzl = (userName) => {
  return request({
    url: '/api/submithtzl/' + userName,
    method: 'get'
  })
}

/* 查询供应商是否可以提交合同资料 */
export const getgyszr = (userName) => {
  return request({
    url: '/api/getgyszr/' + userName,
    method: 'get'
  })
}

/* 查询子表数据 （供货产品及产能） */
export function getProdCap (userName) {
  return request({
    url: '/api/getProdCap/' + userName,
    method: 'get'
  })
}

/* 新增子表 （供货产品及产能） */
export const addProdCap = (data, userName) => {
  return request({
    url: '/api/addProdCap/' + userName,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/* 删除子表数据 （供货产品及产能） */
export function delProdCap (keyId) {
  return request({
    url: '/api/delProdCap/' + keyId,
    method: 'delete'
  })
}


// WEBPACK FOOTER //
// ./src/api/LoginApi.js